import React from 'react';
import './ConfirmationDialog.css';

interface ConfirmationDialogProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationDialog = ({ message, onConfirm, onCancel }: ConfirmationDialogProps) => {
  // Prevent clicks inside the modal from closing it
  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className="confirmation-backdrop" onClick={onCancel}>
      <div className="confirmation-modal" onClick={handleModalClick}>
        <p className="confirmation-message">{message}</p>
        <div className="confirmation-actions">
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};